import NAVBAR from "components/navbar";

function MeuCupom(){
    return <div>
        <NAVBAR />
        <h1>Meu Cupom</h1>
    </div>
}

export default MeuCupom;